import { createStore } from 'redux';
import { createBrowserHistory } from 'history';
import middleware from './middleware';
import reducers from './rootReducers';

const history = createBrowserHistory();
const store = createStore(reducers, middleware(history));

export default store;
